import React from 'react'
import Helmet from 'react-helmet'

const locales = {
    "en": "en_US"
}

const Meta = (data) => {
    const lang = data.lang || "en"
    const siteName = data.siteName || "Option Tracker"
    const title = data.title || siteName
    const fullTitle = /options?\s+tracker/i.test(title) ? title : `${title} | ${siteName}`
    const description = data.description
    const image = data.image ? `${data.image}` : undefined
    const script = data.script !== undefined && data.script
    const canonical = data.canonical ? `${data.canonical}` : undefined
    const type = data.type || "website"
    const width = image && (data.width || 1200)
    const height = image && (data.height || 630)
    const imageAlt = data.imageAlt || fullTitle
    const robots = data.robots
    const twitterHandle = data.twitterHandle || "@OptionTrackerIo"
    const locale = locales[lang] || locales.en
    const author = data.author || siteName


    return (
        <Helmet>
            <html lang={lang} />
            <title>{fullTitle}</title>
            {description ? <meta name="description" content={description} /> : null}
            <meta name="author" content={author} />
            {canonical ? <link rel="canonical" href={canonical} /> : null}
            {canonical ? <link rel="alternate" href={canonical} hrefLang={lang} /> : null}
            {canonical ? <link rel="alternate" href={canonical} hrefLang="x-default" /> : null}
            {robots ? <meta name="robots" content={robots} /> : null}
            {image ? <link rel="image_src" href={image} /> : null}
            {image ? <meta itemProp="image" content={image} /> : null}

            <meta property="og:site_name" content={siteName} />
            <meta property="og:title" content={fullTitle} />
            {description ? <meta property="og:description" content={description} /> : null}
            {canonical ? <meta property="og:url" content={canonical} /> : null}
            <meta property="og:locale" content={locale} />
            <meta property="og:type" content={type} />
            {image ? <meta property="og:image" content={image} /> : null}
            {image ? <meta property="og:image:secure_url" content={image} /> : null}
            {width ? <meta property="og:image:width" content={width} /> : null}
            {height ? <meta property="og:image:height" content={height} /> : null}
            {image ? <meta property="og:image:alt" content={imageAlt} /> : null}

            <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
            <meta name="twitter:title" content={fullTitle} />
            {description ? <meta name="twitter:description" content={description} /> : null}
            {image ? <meta name="twitter:image" content={image} /> : null}
            {image ? <meta name="twitter:image:alt" content={imageAlt} /> : null}
            {canonical ? <meta name="twitter:url" content={canonical} /> : null}
            <meta name="twitter:site" content={twitterHandle} />
            <meta name="twitter:creator" content={twitterHandle} />
            {script}
        </Helmet>
    )
}

export default Meta
